import { cn } from "@/lib/utils";

interface CodeChipProps {
  codeId: string;
  code: string;
  description: string;
  isExpected: boolean;
  isPresent: boolean;
}

interface DiagnosisCodeChipProps extends CodeChipProps {
  isOptional: boolean;
  isPositionCorrect: boolean;
}

export const DiagnosisCodeChip = ({
  code,
  description,
  isExpected,
  isPresent,
  isPositionCorrect,
  isOptional,
}: DiagnosisCodeChipProps) => {
  return (
    <div
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-3 py-1 text-sm font-medium max-w-full relative cursor-pointer",
        isPresent && isExpected && isPositionCorrect
          ? "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-100"
          : isOptional
            ? "bg-gray-200 text-gray-800 dark:bg-gray-900 dark:text-gray-100"
            : isPresent && !isPositionCorrect
              ? "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-100"
              : "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-100",
      )}
      tabIndex={0}
    >
      <span className="font-semibold shrink-0">{code}</span>
      <span className="mx-1 shrink-0">•</span>
      <span className="truncate">{description}</span>
      <span>{isPresent && !isExpected ? "[Unexpected] " : ""}</span>
      <span>{!isPresent && isExpected ? (isOptional ? "[Missing][Optional] " : "[Missing] ") : ""}</span>
    </div>
  );
};
